import React, { useState, useEffect, useRef } from "react";
import "react-datepicker/dist/react-datepicker.css";
import { useNavigate } from "react-router-dom";
import { optionProductsByProducts } from "../Options";
import Sidebar from "../Sidebar";
import Multiselect from "multiselect-react-dropdown";
import { jwtDecode } from "jwt-decode";
import InputFieldPerCotton from "./InputField";
export default function PriceFormProduct() {
  const [date, setDate] = useState("2023-08-09");
  //options
  const [selectedOptions, setSelectedOptions] = useState([]);
  //min-max states
  const [check, setCheck] = useState(false);
  const [displayMessage, setDisplayMessage] = useState(false);
  //province items
  const [options, setOptions] = useState([]);

  const [bajra, setBajra] = useState({
    by_product_id: "65",
    by_product: "Bajra",
    product_id: "12",
    product: "Bajra",
    minimum: "",
    maximum: "",
    arrivals: "",
    arrivalsUnit: "",
  });
  const [cornGradeA, setCornGradeA] = useState({
    by_product_id: "19",
    by_product: "Corn (Grade A)",
    product_id: "5",
    product: "Corn",
    minimum: "",
    maximum: "",
    arrivals: "",
    arrivalsUnit: "",
  });
  const [cornGradeB, setCornGradeB] = useState({
    by_product_id: "83",
    by_product: "Corn (Grade B)",
    product_id: "5",
    product: "Corn",
    minimum: "",
    maximum: "",
    arrivals: "",
    arrivalsUnit: "",
  });
  const [cornGradeC, setCornGradeC] = useState({
    by_product_id: "84",
    by_product: "Corn (Grade C)",
    product_id: "5",
    product: "Corn",
    minimum: "",
    maximum: "",
    arrivals: "",
    arrivalsUnit: "",
  });
  const [banola, setBanola] = useState({
    by_product_id: "11",
    by_product: "Banola",
    product_id: "1",
    product: "Cotton",
    minimum: "",
    maximum: "",
    arrivals: "",
    arrivalsUnit: "",
  });
  const [banolaKhal, setBanolaKhal] = useState({
    by_product_id: "13",
    by_product: "Banola-Khal",
    product_id: "1",
    product: "Cotton",
    minimum: "",
    maximum: "",
    arrivals: "",
    arrivalsUnit: "",
  });
  const [banolaOil, setBanolaOil] = useState({
    by_product_id: "12",
    by_product: "Banola-Oil",
    product_id: "1",
    product: "Cotton",
    minimum: "",
    maximum: "",
    arrivals: "",
    arrivalsUnit: "",
  });
  const [phutti, setPhutti] = useState({
    by_product_id: "7",
    by_product: "Phutti",
    product_id: "1",
    product: "Cotton",
    minimum: "",
    maximum: "",
    arrivals: "",
    arrivalsUnit: "",
  });
  const [canola, setCanola] = useState({
    by_product_id: "61",
    by_product: "Canola",
    product_id: "9",
    product: "Edible Oil",
    minimum: "",
    maximum: "",
    arrivals: "",
    arrivalsUnit: "",
  });
  const [canolaOil, setCanolaOil] = useState({
    by_product_id: "39",
    by_product: "Canola-Oil",
    product_id: "9",
    product: "Edible Oil",
    minimum: "",
    maximum: "",
    arrivals: "",
    arrivalsUnit: "",
  });
  const [sarso, setSarso] = useState({
    by_product_id: "54",
    by_product: "Sarso",
    product_id: "9",
    product: "Edible Oil",
    minimum: "",
    maximum: "",
    arrivals: "",
    arrivalsUnit: "",
  });
  const [sarsoKhal, setSarsoKhal] = useState({
    by_product_id: "63",
    by_product: "Sarso-Khal",
    product_id: "9",
    product: "Edible Oil",
    minimum: "",
    maximum: "",
    arrivals: "",
    arrivalsUnit: "",
  });
  const [sarsoOil, setSarsoOil] = useState({
    by_product_id: "37",
    by_product: "Sarso-Oil",
    product_id: "9",
    product: "Edible Oil",
    minimum: "",
    maximum: "",
    arrivals: "",
    arrivalsUnit: "",
  });
  const [soybeanOil, setSoybeanOil] = useState({
    by_product_id: "40",
    by_product: "Soybean-Oil",
    product_id: "9",
    product: "Edible Oil",
    minimum: "",
    maximum: "",
    arrivals: "",
    arrivalsUnit: "",
  });
  const [sunflower, setSunflower] = useState({
    by_product_id: "55",
    by_product: "Sunflower",
    product_id: "9",
    product: "Edible Oil",
    minimum: "",
    maximum: "",
    arrivals: "",
    arrivalsUnit: "",
  });
  const [sunflowerOil, setSunflowerOil] = useState({
    by_product_id: "38",
    by_product: "Sunflower-Oil",
    product_id: "9",
    product: "Edible Oil",
    minimum: "",
    maximum: "",
    arrivals: "",
    arrivalsUnit: "",
  });
  const [ajwain, setAjwain] = useState({
    by_product_id: "80",
    by_product: "Ajwain",
    product_id: "14",
    product: "Herbals",
    minimum: "",
    maximum: "",
    arrivals: "",
    arrivalsUnit: "",
  });
  const [honey, setHoney] = useState({
    by_product_id: "77",
    by_product: "Honey",
    product_id: "14",
    product: "Herbals",
    minimum: "",
    maximum: "",
    arrivals: "",
    arrivalsUnit: "",
  });
  const [ispaghol, setIspaghol] = useState({
    by_product_id: "78",
    by_product: "Ispaghol",
    product_id: "14",
    product: "Herbals",
    minimum: "",
    maximum: "",
    arrivals: "",
    arrivalsUnit: "",
  });
  const [kalonji, setKalonji] = useState({
    by_product_id: "79",
    by_product: "Kalonji",
    product_id: "14",
    product: "Herbals",
    minimum: "",
    maximum: "",
    arrivals: "",
    arrivalsUnit: "",
  });
  const [saunf, setSaunf] = useState({
    by_product_id: "82",
    by_product: "Saunf",
    product_id: "14",
    product: "Herbals",
    minimum: "",
    maximum: "",
    arrivals: "",
    arrivalsUnit: "",
  });
  const [tukhMalanga, setTukhMalanga] = useState({
    by_product_id: "81",
    by_product: "Tukh Malanga",
    product_id: "14",
    product: "Herbals",
    minimum: "",
    maximum: "",
    arrivals: "",
    arrivalsUnit: "",
  });
  const [till, setTill] = useState({
    by_product_id: "64",
    by_product: "Till",
    product_id: "11",
    product: "Sesame",
    minimum: "",
    maximum: "",
    arrivals: "",
    arrivalsUnit: "",
  });
  const [hybirdChilli, setHybirdChilli] = useState({
    by_product_id: "70",
    by_product: "Hybird Chilli",
    product_id: "10",
    product: "Spices",
    minimum: "",
    maximum: "",
    arrivals: "",
    arrivalsUnit: "",
  });
  const [longiChilli, setLongiChilli] = useState({
    by_product_id: "69",
    by_product: "Longi Chilli",
    product_id: "10",
    product: "Spices",
    minimum: "",
    maximum: "",
    arrivals: "",
    arrivalsUnit: "",
  });
  const [richStarChilli, setRichStarChilli] = useState({
    by_product_id: "71",
    by_product: "Rich Star Chilli",
    product_id: "10",
    product: "Spices",
    minimum: "",
    maximum: "",
    arrivals: "",
    arrivalsUnit: "",
  });
  const [flour, setFlour] = useState({
    by_product_id: "59",
    by_product: "Flour",
    product_id: "3",
    product: "Wheat",
    minimum: "",
    maximum: "",
    arrivals: "",
    arrivalsUnit: "",
  });
  const [maida, setMaida] = useState({
    by_product_id: "72",
    by_product: "Maida",
    product_id: "3",
    product: "Wheat",
    minimum: "",
    maximum: "",
    arrivals: "",
    arrivalsUnit: "",
  });
  const [sorghum, setSorghum] = useState({
    by_product_id: "75",
    by_product: "Sorghum",
    product_id: "3",
    product: "Wheat",
    minimum: "",
    maximum: "",
    arrivals: "",
    arrivalsUnit: "",
  });
  const [straw, setStraw] = useState({
    by_product_id: "62",
    by_product: "Straw",
    product_id: "3",
    product: "Wheat",
    minimum: "",
    maximum: "",
    arrivals: "",
    arrivalsUnit: "",
  });
  const [wheat, setWheat] = useState({
    by_product_id: "16",
    by_product: "Wheat",
    product_id: "3",
    product: "Wheat",
    minimum: "",
    maximum: "",
    arrivals: "",
    arrivalsUnit: "",
  });

  const all = [
    bajra,
    cornGradeA,
    cornGradeB,
    cornGradeC,
    banola,
    banolaKhal,
    banolaOil,
    phutti,
    canola,
    canolaOil,
    sarso,
    sarsoKhal,
    sarsoOil,
    soybeanOil,
    sunflower,
    sunflowerOil,
    till,
    flour,
    maida,
    sorghum,
    straw,
    wheat,
  ];

  //references
  const stationRef = useRef(null);

  useEffect(() => {
    const preventNumberInputScroll = (event) => {
      if (event.target.type === "number") {
        event.preventDefault();
      }
    };

    document.addEventListener("wheel", preventNumberInputScroll, {
      passive: false,
    });

    return () => {
      document.removeEventListener("wheel", preventNumberInputScroll);
    };
  }, []);

  const nav = useNavigate();

  const navigateToPrices = () => {
    nav("/prices");
  };

  useEffect(() => {
    const today = new Date().toISOString().split("T")[0];
    setDate(today);
  }, []);

  useEffect(() => {
    let k = 0;
    for (let i = 0; i < all.length; i++) {
      if (Number(all[i].minimum) > Number(all[i].maximum)) {
        k++;
      } else k = k;
    }
    if (k > 0) {
      setDisplayMessage(true);
      setCheck(false);
    } else {
      setDisplayMessage(false);
      setCheck(true);
    }
  }, [all]);

  const token = sessionStorage.getItem("token");
  const ferrit = async () => {
    if (token) {
      const response = await fetch(
        `${process.env.REACT_APP_API_URL}/admin/stations`,
        {
          headers: {
            "x-access-token": token,
          },
        }
      );
      const data = await response.json();
      setOptions(data);
    } else {
     // console.log("No token!");
    }
  };

  useEffect(() => {
    ferrit();
  }, []);


  //for the product
  const handleSubmit2 = (e) => {
    e.preventDefault();
    //Insert submitters name
    const token = sessionStorage.getItem("token");
    const user = jwtDecode(token);

    if (selectedOptions.length < 1) {
      alert("Select a station before submitting.");
      return;
    }
    const price0 = all.map((option) => {
      const returnValue = {
        date: date,
        product_id: option.product_id,
        product: option.product,
        by_product_id: option.by_product_id,
        by_product: option.by_product,
        province_id: selectedOptions[0].province_id,
        province: selectedOptions[0].province,
        district_id: selectedOptions[0].district_id,
        station_id: selectedOptions[0].value,
        station: selectedOptions[0].name,
        minimum: option.minimum,
        maximum: option.maximum,
        user_name: user.userName,
      };

      if (option.arrivals) {
        returnValue.arrivals = parseInt(option.arrivals);
      }

      if (option.arrivalsUnit) {
        returnValue.arrivalsUnit = parseInt(option.arrivalsUnit);
      }

      return returnValue;
    });

    const prices = price0.filter((pric) => {
      return pric.minimum != false;
    });

    fetch(`${process.env.REACT_APP_API_URL}/admin/prices`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "x-access-token": token,
      },
      body: JSON.stringify(prices),
    })
      .then(() => {
        navigateToPrices();
      })
      .catch((err) => {
       // console.log("Unable to add record" + err);
      });
  };

  //dealing with multiple states
  const handleSelectStateOptions = (selectedList) => {
    setSelectedOptions(selectedList);
  };

  return (
    <>
      <div className="sidebar">
        <Sidebar />
      </div>
      <div className="row">
        <div className="col">
          <div style={{ position: "center" }}>
            <form onSubmit={handleSubmit2} className="needs-validation">
              <div class="mb-3" id="tabler">
                <h1>Price Form</h1>

                <div className="row">
                  <div className="col-md-6">
                    <div>
                      <div className="mb-3">
                        <label htmlFor="date" className="form-label">
                          Date
                        </label>
                        <input
                          id="num-value"
                          type="date"
                          className="form-control"
                          min="0"
                          required
                          value={date || ""}
                          onChange={(e) => setDate(e.target.value)}
                        />
                      </div>
                      {/* Rest of your form */}
                    </div>
                  </div>
                  <div className="col-md-6">
                    <label for="formGroupExampleInput2" class="form-label">
                      Station
                    </label>
                    <Multiselect
                      options={options}
                      displayValue="name"
                      selectedValues={selectedOptions}
                      onSelect={handleSelectStateOptions}
                      onRemove={(selectedList) => {
                        setSelectedOptions(selectedList);
                      }}
                      closeOnSelect={false}
                      avoidHighlightFirstOption
                      ref={stationRef}
                      selectionLimit={1}
                      required={true}
                    />
                  </div>
                </div>

                <div className="row">
                  <InputFieldPerCotton
                    setter={setPhutti}
                    item={phutti}
                    value={optionProductsByProducts[7].name}
                  ></InputFieldPerCotton>
                  <InputFieldPerCotton
                    setter={setBanola}
                    item={banola}
                    value={optionProductsByProducts[4].name}
                  ></InputFieldPerCotton>
                  <InputFieldPerCotton
                    setter={setBanolaOil}
                    item={banolaOil}
                    value={optionProductsByProducts[6].name}
                  ></InputFieldPerCotton>
                  <InputFieldPerCotton
                    setter={setBanolaKhal}
                    item={banolaKhal}
                    value={optionProductsByProducts[5].name}
                  ></InputFieldPerCotton>
                  <hr style={{color:"white"}}/>
                  <InputFieldPerCotton
                    setter={setWheat}
                    item={wheat}
                    value={optionProductsByProducts[35].name}
                  ></InputFieldPerCotton>
                  <InputFieldPerCotton
                    setter={setStraw}
                    item={straw}
                    value={optionProductsByProducts[34].name}
                  ></InputFieldPerCotton>
                  <InputFieldPerCotton
                    setter={setFlour}
                    item={flour}
                    value={optionProductsByProducts[31].name}
                  ></InputFieldPerCotton>
                  <InputFieldPerCotton
                    setter={setMaida}
                    item={maida}
                    value={optionProductsByProducts[32].name}
                  ></InputFieldPerCotton>
                  <InputFieldPerCotton
                    setter={setSorghum}
                    item={sorghum}
                    value={optionProductsByProducts[33].name}
                  ></InputFieldPerCotton>
                  <hr style={{color:"white"}}/>
                  <InputFieldPerCotton
                    setter={setSarso}
                    item={sarso}
                    value={optionProductsByProducts[15].name}
                  ></InputFieldPerCotton>
                  <InputFieldPerCotton
                    setter={setSarsoOil}
                    item={sarsoOil}
                    value={optionProductsByProducts[17].name}
                  ></InputFieldPerCotton>
                  <InputFieldPerCotton
                    setter={setSarsoKhal}
                    item={sarsoKhal}
                    value={optionProductsByProducts[16].name}
                  ></InputFieldPerCotton>
                  <InputFieldPerCotton
                    setter={setCanola}
                    item={canola}
                    value={optionProductsByProducts[13].name}
                  ></InputFieldPerCotton>
                  <InputFieldPerCotton
                    setter={setCanolaOil}
                    item={canolaOil}
                    value={optionProductsByProducts[14].name}
                  ></InputFieldPerCotton>
                  <InputFieldPerCotton
                    setter={setSunflower}
                    item={sunflower}
                    value={optionProductsByProducts[19].name}
                  ></InputFieldPerCotton>
                  <InputFieldPerCotton
                    setter={setSunflowerOil}
                    item={sunflowerOil}
                    value={optionProductsByProducts[20].name}
                  ></InputFieldPerCotton>
                  <InputFieldPerCotton
                    setter={setSoybeanOil}
                    item={soybeanOil}
                    value={optionProductsByProducts[18].name}
                  ></InputFieldPerCotton>
                  <hr style={{color:"white"}}/>
                  <InputFieldPerCotton
                    setter={setCornGradeA}
                    item={cornGradeA}
                    value={optionProductsByProducts[1].name}
                  ></InputFieldPerCotton>
                  <InputFieldPerCotton
                    setter={setCornGradeB}
                    item={cornGradeB}
                    value={optionProductsByProducts[2].name}
                  ></InputFieldPerCotton>
                  <InputFieldPerCotton
                    setter={setCornGradeC}
                    item={cornGradeC}
                    value={optionProductsByProducts[3].name}
                  ></InputFieldPerCotton>
                  <hr style={{color:"white"}}/>
                  <InputFieldPerCotton
                    setter={setTill}
                    item={till}
                    value={optionProductsByProducts[27].name}
                  ></InputFieldPerCotton>
                  <InputFieldPerCotton
                    setter={setBajra}
                    item={bajra}
                    value={optionProductsByProducts[0].name}
                  ></InputFieldPerCotton>
                  <hr style={{color:"white"}}/>
                </div>
              </div>

              {/**Submit Button */}
              {check && (
                <button
                  type="submit"
                  id="button-submit"
                  className="btn submit-btn"
                >
                  Submit
                </button>
              )}

              {/**Error if min and max values are not agreeing */}
              {displayMessage && (
                <div class="alert alert-danger" id="button-submit" role="alert">
                  Minimum value cannot be greate than maximum value
                </div>
              )}
            </form>
          </div>
        </div>
      </div>
      <div>
      </div>
    </>
  );
}
